import { render, staticRenderFns } from "./AtlasLogo.vue?vue&type=template&id=18246762&scoped=true&"
var script = {}
import style0 from "./AtlasLogo.vue?vue&type=style&index=0&id=18246762&prod&scoped=true&lang=css&"
import style1 from "./AtlasLogo.vue?vue&type=style&index=1&id=18246762&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18246762",
  null
  
)

export default component.exports